import { httpClient } from './httpClient';

export interface Type {
    id: number;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const typeService = {
    getAllTypes: async () => {
        try {
            return await httpClient.get<Type[]>('/api/types');
        } catch (error) {
            // Return empty array instead of throwing error when no types are found
            return [];
        }
    },

    getTypeById: async (id: number) => {
        return httpClient.get<Type>(`/api/types/${id}`);
    },

    createType: async (name: string, description?: string) => {
        return httpClient.post<Type>('/api/types', { name, description });
    },

    updateType: async (id: number, name: string, description?: string) => {
        return httpClient.put<Type>(`/api/types/${id}`, { name, description });
    },

    deleteType: async (id: number) => {
        return httpClient.delete<Type>(`/api/types/${id}`);
    }
};
